export default "__VITE_ASSET__71571d5f__"